import { create } from 'zustand';

export default create((set) => ({
  activeTab: false,
  setActiveTab: (activeTab) => set({ activeTab }),
}));
